<template>
  <v-form
    lazy-validation
    v-model="valid"
    @submit.prevent="submit"
    ref="form"
  >
      <v-container class="text-center">
        <v-row>
          <v-col cols="12">
            <v-text-field
              filled
              data-cy="FormEmailLog-recipients"
              :label="$$t('recipients')"
              v-model="localEmailLog.recipients"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field
              filled
              data-cy="FormEmailLog-subject"
              :label="$$t('subject')"
              v-model="localEmailLog.subject"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-text-field
              filled
              data-cy="FormEmailLog-sent"
              :label="$$t('sent')"
              v-model="localEmailLog.sent"
            />
          </v-col>
        </v-row>
        <div class="d-flex justify-end mb-6">
          <v-btn color="default" outlined class="ml-4 btn-cancel" @click="cancel"
            data-cy="FormEmailLog-button-cancel">
            {{ $t('common.buttons.cancel') }}
          </v-btn>
          <v-btn color="primary" type="submit" class="ml-4" :loading="isSaving"
            data-cy="FormEmailLog-button-save">
              {{ $t('common.buttons.save') }}
            </v-btn>
        </div>
      </v-container>
  </v-form>
</template>

<script>
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'FormEmailLog',
  module: 'Shop',
  mixins: [loading],
  props: {
    /**
    * Set the text box value. Default: undefined,
    */
    EmailLog: {
      type: Object,
      default: undefined,
    },
  },
  data() {
    return {
      /**
      * Hold form validation state
      */
      valid: false,
      /**
      * Local value used for property localEmailLog
      */
      localEmailLog: {},
    };
  },
  watch: {
    EmailLog() {
      this.localEmailLog = this.EmailLog;
    },
  },
  created() {
    this.localEmailLog = this.EmailLog;
  },
  methods: {
    /** Submit Form data trigger
     * @event save
     * @type {object}
     */
    submit() {
      // validate
      if (this.$refs.form.validate()) {
        this.$emit('save', this.localEmailLog);
        this.isSaving = true;
      }
    },
    /** Cancel form trigger
     * @event cancel
     */
    cancel() {
      this.$emit('cancel');
    },
  },
};
</script>

<docs>
# FormEmailLog example

'''js
<FormEmailLog :EmailLog="EmailLog" />
'''
</docs>
